import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import InputDateUI from '../../../../widgets/form/InputDateUI'

const ExternalStatusModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  cpCsStatus, onCpCsStatusChange, cpCsStatusError, setCpCsStatusError, cpCsStatusList,
  reuploadMessage, onReuploadMessageChange, reuploadMessageError, setReuploadMessageError,
  waivedMessage, onWaivedMessageChange, waivedMessageError, setWaivedMessageError,
  extendedDueDate, onExtendedDueDateChange, extendedDueDateError,
  extendedDueDateReason, onExtendedDueDateReasonChange, extendedDueDateReasonError, setExtendedDueDateReasonError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='status' label='Status'
      required={true}
      value={cpCsStatus} onChange={onCpCsStatusChange} optionList={cpCsStatusList}
      error={cpCsStatusError} setError={setCpCsStatusError}
    />

    {
      cpCsStatus &&
      <>
        {
          cpCsStatus === 'reupload' &&
          <InputTextSF type='text' name='reuploadMessage' label='Reupload message'
            required={true} maxLength={100}
            value={reuploadMessage} onChange={onReuploadMessageChange}
            error={reuploadMessageError} setError={setReuploadMessageError}
          />
        }
        {
          cpCsStatus === 'reviewed_and_requires_resubmission' &&
          <InputTextSF type='text' name='reuploadMessage' label='Resubmission reason'
            required={true} maxLength={100}
            value={reuploadMessage} onChange={onReuploadMessageChange}
            error={reuploadMessageError} setError={setReuploadMessageError}
          />
        }
        {
          cpCsStatus === 'waived' &&
          <InputTextSF type='text' name='waivedMessage' label='Waived message'
            required={true} maxLength={100}
            value={waivedMessage} onChange={onWaivedMessageChange}
            error={waivedMessageError} setError={setWaivedMessageError}
          />
        }
        {
          cpCsStatus === 'due_date_extended' &&
          <>
            <InputDateUI
              context={context}
              name='extendedDueDate'
              label='Extended Due Date'
              required={true}
              selectedDateISO={extendedDueDate}
              onChange={onExtendedDueDateChange}
              help='Select the new extended due date for this document'
              error={extendedDueDateError}
            />
            <InputTextSF type='text' name='extendedDueDateReason' label='Reason for extension'
              required={true} maxLength={200}
              value={extendedDueDateReason} onChange={onExtendedDueDateReasonChange}
              error={extendedDueDateReasonError} setError={setExtendedDueDateReasonError}
            />
          </>
        }
      </>
    }
  </ModalFormUI>

export default ExternalStatusModalUI